import { ReactElement } from 'react';
import OptionSection from './OptionSection';
import GroupHeader from './GroupHeader';
import AddContentButtons from './AddContentButtons';
import SessionDuplicateSection from './SessionDuplicateSection';
import SessionColorSection from './SessionColorSection';
import ChangeSessionTypeSection from './ChangeSessionTypeSection';
import MeteorologicalSourceSection from './meteorological/MeteorologicalSourceSection';
import SurfaceQualitySection from './SurfaceQualitySection';
import SessionDangerActions from './SessionDangerActions';
import SessionHealthVarsForm from '../SessionHealthVarsForm';

interface SessionOptionsProps {
  sessionId: string;
  session: any;
  updateSession: any;
  invalidateSession: () => Promise<void>;
  clearUnsavedChanges: () => void;
}

/**
 * The collapsed "Options" block below the session cards: content seeds, session
 * management, and per-session settings. Rendered only for existing sessions.
 * Must sit inside the session FormProvider (some sections read the form context).
 */
export default function SessionOptions({
  sessionId,
  session,
  updateSession,
  invalidateSession,
  clearUnsavedChanges,
}: SessionOptionsProps): ReactElement {
  return (
    <OptionSection title="Options" variant="top">
      <GroupHeader label="Content" />
      <AddContentButtons
        sessionId={sessionId}
        session={session}
        updateSession={updateSession}
        invalidateSession={invalidateSession}
      />

      <GroupHeader label="Session" />
      <SessionDuplicateSection sessionId={sessionId} />
      <SessionColorSection sessionId={sessionId} />

      <GroupHeader label="Analysis Settings" />
      <ChangeSessionTypeSection
        sessionId={sessionId}
        session={session}
        updateSession={updateSession}
        invalidateSession={invalidateSession}
      />
      <MeteorologicalSourceSection
        sessionId={sessionId}
        session={session}
        updateSession={updateSession}
        invalidateSession={invalidateSession}
      />
      <SurfaceQualitySection
        session={session}
        updateSession={updateSession}
        invalidateSession={invalidateSession}
      />

      {/* Per-session health-warning threshold overrides */}
      {session?.id && <SessionHealthVarsForm session={session} sessionId={sessionId} />}

      <SessionDangerActions
        sessionId={sessionId}
        session={session}
        updateSession={updateSession}
        invalidateSession={invalidateSession}
        clearUnsavedChanges={clearUnsavedChanges}
      />
    </OptionSection>
  );
}
